/** RFC 4122 v4 UUID for correlation IDs and client-side keys. */
export function randomUuid(): string {
  return crypto.randomUUID();
}
